import { sendOneSignalSubscriptionToBackend } from "./sendOneSignalSubscriptionToBackend";
import { Helper } from "../common/helper";

export async function initializeOneSignalUsingMedian()
{
    try
    {
        if (Helper.hasMedianOneSignal())
        {
            const oneSignalInfo = await (window as any).median.onesignal.onesignalInfo();

            if (oneSignalInfo.subscription.id)
            {
                await sendOneSignalSubscriptionToBackend(oneSignalInfo.subscription.id);
            }
        }
    }
    catch (err)
    {
        console.error("Failed to get OneSignal info from Median:", err);
    }
}
